import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { User } from './user.interface';
import { UserService } from './user.service';

const service = new UserService();

export interface UserState {
   users: Array<User>;
}

const UserStore: Module<UserState, StoreState> = {
   namespaced: true,
   state: {
      users: [],
   },
   getters: {},
   mutations: {
      SET_USERS(state, users: Array<User>) {
         state.users = users;
      },
   },
   actions: {
      async searchUsers(context, query: LocationQuery) {
         const response = await service.getUsers({ ...query, page: '1' });
         const mappedUsers = response.data.map((user) => ({ ...user, name: `${user.first_name} ${user.last_name}` }));
         context.commit('SET_USERS', mappedUsers);
         return mappedUsers;
      },
      async getUser(context, { userId, query }: { userId: number; query: LocationQuery }) {
         const response = await service.getUser(userId, query);
         return response.data;
      },
   },
};

export default UserStore;
